"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'step.list.title': '入职步骤',
    'step.list.empty': '未找到步骤',
};
